<template>
  <div v-if="booking.status.status === 'DROPPED'">
        <v-row>
      <v-col>
        <h3 class="my-2">Request exchange or collection</h3>
        <p> Select preferred date and time </p>
      </v-col>
    </v-row>
    <v-row>
       <v-col md="3">
        <v-menu
            ref="datePicker"
            v-model="datePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                filled
                v-model="dateFormatted"
                label="Date"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              no-title
              :min="minDate"
              @input="datePicker = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="3">
        <v-select
            filled
            prepend-inner-icon="mdi-clock"
            label="Time"
            :items="preferredTimes"
            v-model="preferredTime"
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="mt-n4">
      <v-col md="6">
        <v-textarea
            filled
            height="100"
            label="Special instructions"
            hint="Instructions for the driver"
            v-model="instructions"
        ></v-textarea>
      </v-col>
    </v-row>
    <Loading v-if="loading"/>
    <v-row justify="center">
      <v-col>
        <v-dialog
          v-model="dialog1"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              block
              rounded
              height="50"
              class="primary">Exchange </v-btn>
          </template>

          <v-card v-if="!loading">
            <v-card-title class="text-h6 grey lighten-2">
              Requesting Exchange
            </v-card-title>

            <v-card-text class="pt-6" style="font-size: 16px;">
              Confirm exchange booking ?
            </v-card-text>
            <v-divider></v-divider>
            <v-skeleton-loader
              v-if="loading"
              loading
              light
              class=""
              max-width="100%"
              type="list-item"
            > </v-skeleton-loader>
            <v-card-actions v-if="!loading">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="dialog1 = false"
              >
                Cancel
              </v-btn>
              <v-btn
                class="primary white--text"
                outlined
                @click="exchange()"
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col>
        <v-dialog
          v-model="dialog2"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              block
              rounded
              height="50"
              class="primary">Collection </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h6 grey lighten-2">
              Requesting Collection
            </v-card-title>

            <v-card-text class="pt-6" style="font-size: 16px;">
              Confirm collection booking ?
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="dialog2 = false"
              >
                Cancel
              </v-btn>
              <v-btn
                class="primary white--text"
                outlined
                @click="collect()"
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col align="start" style='margin-top: 32px'>
        <strong>Driver</strong> <br /><div>{{ booking.driver.firstName + ' ' + booking.driver.lastName }}</div>
      </v-col>
    </v-row>
    <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block' : '' " class="main--text">
      <v-col>
        <h3>Service type</h3>
        {{ booking.vehicle.name }}
      </v-col>
      <v-col>
        <h3>Waste type</h3>
        {{ booking.waste.name }}
      </v-col>
      <v-col>
        <h3>Instruction</h3>
        {{ booking.instructions }}
      </v-col>
    </v-row>

    <v-row v-if="this.isNull">
      <v-col xs="16" sm="16" md="3">
        <v-text-field
        type="number"
        label="Postal Code"
        v-model="postCode"
        @change="checkCode"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  name: 'DroppedBin',
  components: {
    Loading
  },
  props: {
    booking: Object
  },
  data(){
    return{
      timeStamp: new Date(),
      minDate: new Date().toISOString().substr(0, 10),
      preferredTime: undefined,
      instructions: '',
      preferredTimes: [ 'AM', 'PM' ],
      date: undefined,
      dateFormatted: undefined,
      datePicker: false,
      price: '',
      isNull: false,
      postCode: '',
      dialog1: false,
      dialog2: false,
      loading: false,
    }
  },
  computed: {
    bookingError() {
      return this.$store.getters.getBookingError;
    },
    bookingLength(){
      return this.$store.getters.getBookingLength +1;
    },
    orderNumber(){
      return parseInt(this.$store.getters.getOrderNumber);
    },
    orderId(){
      return parseInt(this.$store.getters.getOrderId);
    },
    wasteTypes() {
      return this.$store.getters.getWasteTypes;
    },
    userCard() {
      let cardId = this.booking.customer.card ? this.booking.customer.card.registrationId :
      this.$store.getters['auth/getUser'].card ? this.$store.getters['auth/getUser'].card.registrationId : '';
      return cardId;
    }, 
    fuelLevyPrice() {
      return this.$store.state.fuelLevy.fuelLevyPrice;
    }
  },
  watch:{
    bookingError(error) {
      if (error) {
        alert(error.message);
        this.$router.go();
      }
    },
    date(){
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    formatDate(date){
      if (!date) return null

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`
    },
    parseDate(date){
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async checkCode(){
      return new Promise((resolve, reject) => {
        //get address code and fetch wasteType Area with it, to later update the price
        let address = this.booking.capturedAddress.split(', South Africa').join('');
        let code = address.substr(-4);
        const postalCode = Number.parseInt(this.booking.postCode ? this.booking.postCode : !isNaN(code) ? code : this.postCode.length === 4 ? this.postCode : null);

        if (postalCode.toString().length > 2  && !isNaN(postalCode)) {
          this.$store.dispatch('fetchWasteTypesByArea', postalCode)
          .then(() => {
            return resolve("post code set");
          })
          .catch((err) => reject(err));
        } else {
          this.isNull = true;
          this.dialog1 = false;
          return reject("post code not set");
        }
      })
    },
    async collect(){
      if (!this.date || !this.preferredTime){
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: 'Choose date and time for your collection booking',
          options: {
            timeout: 3000
          }
        });
        this.dialog2 = false;
        return null;
      }
      else{
        const collection = Object.assign({}, this.booking);
        collection.arrival = '';
        collection.status = {
          type: 'COLLECTION',
          status: 'SCHEDULING'
        };
        collection.timeStamp = this.timeStamp;
        collection.preferredTime = this.preferredTime;
        collection.preferredDate = this.date;
        collection.instructions = this.instructions;
        delete collection.id;
        if(this.userCard != '' && this.userCard){
          collection.customer = {
            ...collection.customer,
            card: {
              registrationId: this.userCard
            }
          };
        }

        await this.$store.dispatch('createBooking', collection);
        this.$store.dispatch('updateBooking', {
          ...this.booking,
          status:{
            origin: 'DELIVERY'
          }
        });
      }
    },
    getPrice() {
      return new Promise((resolve, reject) => {
        let waste = this.wasteTypes?.find(w => w.name === this.booking.waste.name);
        if (waste) {
          let vehicle = waste.vehicles.find(v => v.name === this.booking.vehicle.name);
          if (vehicle) {
            this.price = vehicle.cost;
            resolve("Price has been set");
          } else{
            reject("No price set");
          }
        } else {
          reject("No price set");
        }
      });
    },
    async exchange(){
      this.loading = true;
      await this.checkCode().then(async () => {
        setTimeout(async () => {
          await this.getPrice().then(async () => {
            if(!this.date || !this.preferredTime){
              this.$store.dispatch('toastr/addToastr', {
                id: `toast-${Date.now()}`,
                type: 't-warning',
                title: 'Alert',
                message: 'Choose date and time for your exchange booking.',
                options: {
                  timeout: 3000
                }
              });
              this.dialog1 = false;
              this.loading = false;
              return null;
            }
            else{
              const exchange = Object.assign({}, this.booking);
              delete exchange.id;
              delete exchange.arrival;
              delete exchange.serviceNote;
              exchange.parentBookingId = this.booking.id;

              if(this.userCard != '' && this.userCard){
                exchange.customer = {
                  ...exchange.customer,
                  card: {
                    registrationId: this.userCard
                  }
                }
              }

              const calculatePrice = () => {
                let myPrice = Number(this.price);
                return myPrice + this.fuelLevyPrice; // Fuel levy
              };

              await this.$store.dispatch('createBooking', {
                ...exchange,
                parentBookingId: this.booking.id,
                status: { type: 'EXCHANGE', status: 'SCHEDULING'},
                timeStamp: this.timeStamp,
                preferredTime: this.preferredTime,
                preferredDate: this.date,
                instructions: this.instructions,
                cost:{
                  value: calculatePrice(),
                  fuelLevy: this.fuelLevyPrice,
                  currency: 'ZAR',
                  symbol: 'R'
                }
              });
              this.$store.dispatch('updateBooking', {
                ...this.booking,
                status: {
                  ...this.booking.status,
                  locked: true
                }
              });
              this.loading = false;
            }
          
          }).catch((err) => {
            console.log(err)
            this.$store.dispatch('toastr/addToastr', {
              id: `toast-${Date.now()}`,
              type: 't-warning',
              title: 'Alert',
              message: err.message,
              options: {
                timeout: 3000
              }
            });
          })
        }, 2000)
      }).catch(() => {
        this.loading = false;
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: 'No postal code set. Please enter correct postal code',
          options: {
            timeout: 3000
          }
        });
      });
    }
  },
  mounted(){
    
  }
}
</script>
<style scoped>
span{
  font-size: 50px;
}
</style>